import React from 'react';
import SearchBar from './partials/searchbar';

const Header = () => (
  <section className="header">
    <SearchBar />
  </section>
);

export default Header;
